import { render, staticRenderFns } from "./ExaminationPhotos.vue?vue&type=template&id=eb4221ce"
import script from "./ExaminationPhotos.vue?vue&type=script&lang=js"
export * from "./ExaminationPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports